import React, { useMemo, forwardRef } from 'react';
import { Box, ButtonBase, ButtonBaseProps } from '@mui/material';

/**
 * Component used to render Tab, contains duplication of label to change font-weight without changing width
 */
export const TabComponent: React.FC<ButtonBaseProps & { link?: boolean }> = forwardRef(
  ({ children, link = false, ...rest }, ref) => {
    // shared style between label and selectedLabel
    const sharedLabelSx = useMemo(
      () => ({
        display: 'inherit',
        alignItems: 'inherit',
        justifyContent: 'inherit',
        flexDirection: 'inherit',
        gap: 'inherit',
      }),
      [],
    );

    return (
      <ButtonBase
        ref={ref}
        aria-label="navigation"
        {...(link && { component: 'a' })}
        {...rest}
        tabIndex={rest.className?.includes('Mui-disabled') ? -1 : 0}
      >
        <Box className="FlowTab-labelWrapper" sx={{ ...sharedLabelSx, position: 'relative' }}>
          <Box
            className="FlowTab-label"
            sx={{
              ...sharedLabelSx,
              position: 'absolute',
              // expands from center, can be changed to expand from left/right with left: 0;
            }}
          >
            {children}
          </Box>
          <Box
            className="FlowTab-selectedLabel"
            sx={{
              ...sharedLabelSx,
              fontWeight: '700',
              // hidden by default, appears once Tab is selected (tab.theme)
              opacity: '0',
              position: 'relative',
            }}
            aria-hidden="true"
          >
            {children}
          </Box>
        </Box>
      </ButtonBase>
    );
  },
);
